var path = '/templates/projects.incentives/list.html';
var html = "<div class=container><section class=campaigns><div class=row><div class=col-md-9><h1>{{ 'projectsIncentives.list.incentiveList' | translate }}</h1></div><div class=col-md-3 ng-if=\"isMaster || currentProject.allow_incentive_edit\"><a class=\"btn btn-default pull-right\" ui-sref=\"admin.projects.incentives.new({projectId: currentProject.id})\"><i class=\"fa fa-lock\" ng-if=!currentProject.allow_incentive_edit></i> {{ 'projectsIncentives.list.incentiveRegister' | translate }}</a></div></div><zc-incentive-table project=currentProject incentives=incentives on-update=getAllIncentives shows-detail=true></zc-incentive-table></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.incentives/list.html
// module id = 1414
// module chunks = 0